module.exports = __webpack_public_path__ + "img/digital_platform_2.bd425d15.png";